import { useMutation } from '@tanstack/react-query';

import { logInquiryApi } from '../api/log.adapter';
import type { ListLogsParams } from '../types/log.types';

// Trigger a browser download of an in-memory blob (the server-built CSV). The
// export endpoint needs a Bearer token, so it can't be a plain <a href> — we
// fetch with auth (httpClient), then download the returned blob via an object URL.
function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

// CSV export of the audit log (FEATURE_062). The BE renders + audits + caps the
// export; the FE just downloads the bytes. The caller handles success/error
// toasts (the error carries the server's Korean message, e.g. the 50k-cap text).
export function useExportLogs() {
  return useMutation<void, Error, ListLogsParams>({
    mutationFn: async (params) => {
      const { blob, filename } = await logInquiryApi.exportLogs(params);
      triggerDownload(blob, filename);
    },
  });
}
